import React, { useState, useEffect } from "react";
import {
  postChofer as addChofer,
} from "../helpers/rutaChoferes";

import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import { getIva } from "../helpers/rutaIva";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';


const AddChoferForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codcho: "",
    nombre: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await addChofer(formValues);
      console.log("✅ Chofer creado:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo

        setFormValues({
          codcho: "",
          nombre: "",
          domicilio: "",
          telefono: "",
          cuit: "",
          email: "",
          localidad: "",
        });

        // Si querés cerrar el modal también:
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear chofer:", error);
      // Podés agregar un modal de error si querés
    }
  };


  const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  const [iva, setIva] = useState({ data: {}, loading: true });
  const [rutas, setRutas] = useState({ data: {}, loading: true });

  useEffect(() => {
    getLocalidades().then((localidades) =>
      setLocalidades({ data: localidades, loading: false })
    );
    getIva().then((iva) => setIva({ data: iva, loading: false }));
    getRutas().then((rutas) => setRutas({ data: rutas, loading: false }));
  }, []);

  return (
    <>
      {!localidades.loading && !iva.loading && !rutas.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-3">
                <label>Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  maxLength="50"
                  required
                  value={formValues.nombre}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-4">
                <label>Domicilio</label>
                <input
                  type="text"
                  className="form-control"
                  name="domicilio"
                  maxLength="50"
                  // required
                  value={formValues.domicilio}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Telefono</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefono"
                  maxLength="20"
                  // required
                  value={formValues.telefono}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>CUIT</label>
                <input
                  type="text"
                  className="form-control"
                  name="cuit"
                  maxLength="11"
                  // required
                  value={formValues.cuit}
                  onChange={handleChange}
                />
              </div>

            </div>

            <div className="form-row">

              <div className="form-group mt-3 col-sm-4">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  maxLength="50"
                  // required
                  value={formValues.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group mt-3 col-sm-2">
                <label>Localidad</label>
                <select
                  className="form-control"
                  name="localidad"
                  value={formValues.localidad}
                  onChange={handleChange}
                  required
                >
                  <option value="">Elija opción</option>
                  {localidades.data.localidades.map((loc) => (
                    <option key={loc._id} value={loc._id}>
                      {loc.localidad}
                    </option>
                  ))}
                </select>
              </div>

            </div>

   
            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}

        <Modal
          show={showSuccess}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="animate__animated animate__fadeInDown"
        >
          <Modal.Body className="text-center">
            <div style={{ fontSize: "3rem" }}>🖐</div>
            <h5 className="mt-2">¡Registro generado correctamente!</h5>
            </Modal.Body>
        </Modal>

    </>
  );
};

export default AddChoferForm;
